import { Navigate, useLocation } from 'react-router-dom'

import { buildSigninPath, getNextPath } from '../utils/helpers/signin-redirect.helpers'

/**
 * Logged out on a dashboard page: off to /signin, remembering the page so the
 * visitor lands on it once signed in.
 */
export const RedirectToSignin = () => {
  const { pathname, search, hash } = useLocation()

  return <Navigate to={buildSigninPath(pathname + search + hash)} replace />
}

/**
 * Logged in on /signin: the route tree swaps as soon as the user is set, so
 * this is where a fresh sign-in arrives. It honours `next`, or goes home.
 */
export const RedirectAfterSignin = () => {
  const { search } = useLocation()

  return <Navigate to={getNextPath(search) ?? '/'} replace />
}
